import Global from '../../js/constant.js'

const myspace = {
  state: {
    myspaceDivisionId : Global.myspace_division_id.home, //myspace
    markId : null, //myspace
  },
  getters: {
    myspaceDivisionId(state) { return state.myspaceDivisionId },
    markId(state) { return state.markId },
  },
  mutations: {
    setMyspaceDivisionId (state, value) {
      state.myspaceDivisionId = value
    },
    setMarkId (state, value) {
      state.markId = value
    },
  },
  actions: {},
  modules: {}
}
export default myspace